"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const constants_1 = require("../../../constants/constants");
const eventConstants_1 = require("../../../constants/eventConstants");
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const pressable_1 = __importDefault(require("../../pressable/pressable"));
const loanIdStyles_1 = __importDefault(require("./loanIdStyles"));
const icon_1 = __importDefault(require("../../icon/icon"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const useWebDesktopDesign_1 = __importDefault(require("../../../hooks/useWebDesktopDesign"));
const LoanId = ({ loanId, loanIsVerifying }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const { partner } = useAppSelector_1.default((state) => ({
        partner: state.auth.user.partner,
    }));
    return (react_1.default.createElement(react_native_1.View, { style: [
            isDesktop ? styles_1.default.flexDirectionRow : styles_1.default.flexDirectionColumn,
            styles_1.default.alignCenterCenter,
            styles_1.default.marginTen,
        ] },
        react_1.default.createElement(react_native_1.View, { style: [loanIdStyles_1.default.container, styles_1.default.marginTen] }, partner === 'Quickcheck' ? (react_1.default.createElement(pressable_1.default, { style: styles_1.default.marginTen, onPress: () => react_native_1.Linking.openURL(`${constants_1.QUICKCHECK_CRM_URL}/${loanId}/`), eventName: eventConstants_1.LOAN_ID_PRESS },
            react_1.default.createElement(react_native_paper_1.Title, { style: loanIdStyles_1.default.loanIdStyle }, `Loan ID: ${loanId}`))) : (react_1.default.createElement(react_native_paper_1.Title, { style: loanIdStyles_1.default.loanIdStyle }, `Loan ID: ${loanId}`))),
        loanIsVerifying && (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.alignItemsCenter,
                styles_1.default.whiteBackground,
                styles_1.default.flexDirectionRow,
                styles_1.default.alignRight,
            ] },
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faSpinner, color: colors_1.default.BLUE })),
            react_1.default.createElement(react_native_1.View, { style: [{ marginHorizontal: 5 }] },
                react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlue, styles_1.default.fontSizeText, styles_1.default.fontWeightBold] }, ` Verifying `))))));
};
exports.default = LoanId;
